import { createCustomIcon } from "components/primitives";

import { ReactComponent as Dice1 } from "./Dice1.svg";
import { ReactComponent as Dice2 } from "./Dice2.svg";
import { ReactComponent as Dice3 } from "./Dice3.svg";
import { ReactComponent as Dice4 } from "./Dice4.svg";
import { ReactComponent as Dice5 } from "./Dice5.svg";
import { ReactComponent as Dice6 } from "./Dice6.svg";
import { ReactComponent as DiceBackground_D6 } from "./DiceBackground_D6.svg";
import { ReactComponent as DiceBackground_D6_Blank } from "./DiceBackground_D6_Blank.svg";
import { ReactComponent as DiceBackground_D8 } from "./DiceBackground_D8.svg";
import { ReactComponent as DiceBackground_D8_Blank } from "./DiceBackground_D8_Blank.svg";
import { ReactComponent as DiceBackground_D9 } from "./DiceBackground_D9.svg";
import { ReactComponent as DiceBackground_D9_Blank } from "./DiceBackground_D9_Blank.svg";
import { ReactComponent as DiceBackground_D10 } from "./DiceBackground_D10.svg";
import { ReactComponent as DiceBackground_D10_Blank } from "./DiceBackground_D10_Blank.svg";
import { ReactComponent as DiceBackground_D12 } from "./DiceBackground_D12.svg";
import { ReactComponent as DiceBackground_D12_Blank } from "./DiceBackground_D12_Blank.svg";
import { ReactComponent as DiceBackground_D20 } from "./DiceBackground_D20.svg";
import { ReactComponent as DiceBackground_D20_Blank } from "./DiceBackground_D20_Blank.svg";

export const Dice1Icon = createCustomIcon(Dice1, "Dice1");
export const Dice2Icon = createCustomIcon(Dice2, "Dice2");
export const Dice3Icon = createCustomIcon(Dice3, "Dice3");
export const Dice4Icon = createCustomIcon(Dice4, "Dice4");
export const Dice5Icon = createCustomIcon(Dice5, "Dice5");
export const Dice6Icon = createCustomIcon(Dice6, "Dice6");
export const D6Background = createCustomIcon(DiceBackground_D6, "D6_Background");
export const D8Background = createCustomIcon(DiceBackground_D8, "D8_Background");
export const D9Background = createCustomIcon(DiceBackground_D9, "D9_Background");
export const D10Background = createCustomIcon(DiceBackground_D10, "D10_Background");
export const D12Background = createCustomIcon(DiceBackground_D12, "D8_Background");
export const D20Background = createCustomIcon(DiceBackground_D20, "D8_Background");
export const D6BackgroundBlank = createCustomIcon(DiceBackground_D6_Blank, "D6_Background_Blank");
export const D8BackgroundBlank = createCustomIcon(DiceBackground_D8_Blank, "D8_Background_Blank");
export const D9BackgroundBlank = createCustomIcon(DiceBackground_D9_Blank, "D9_Background_Blank");
export const D10BackgroundBlank = createCustomIcon(
  DiceBackground_D10_Blank,
  "D10_Background_Blank",
);
export const D12BackgroundBlank = createCustomIcon(DiceBackground_D12_Blank, "D8_Background_Blank");
export const D20BackgroundBlank = createCustomIcon(DiceBackground_D20_Blank, "D8_Background_Blank");
